<shell-layout-errors-center>
  <img class="error__img" src="assets/img/errors/error__without_dpf.svg" alt="" />
  <ui-text class="error__title" color="blue-500" size="h4" weight="semibold"
    >Tuvimos un problema con tu depósito
  </ui-text>
  <ui-text class="error__description mb-3" color="blue-300">
    Hubo un error y no pudimos abrir tu <br />
    Depósito a Plazo Fijo. <br />
    Por tu seguridad volveremos al inicio.
  </ui-text>
  <ui-button
    (clicked)="closeModal()"
    class="error__action dpf-button"
    type="primary"
    label="Volver al inicio"
    style="padding-bottom: 30px"
  ></ui-button>
</shell-layout-errors-center>
